/*
 * "Read more" for the collapsible content section.
 *
 * Every row is rendered server side; the ones past the visible count sit in a
 * panel that is clipped to zero height, so the toggle reveals markup that is
 * already on the page rather than fetching anything.
 *
 * Two details worth keeping:
 *   · The panel is `visibility: hidden` while closed, not just clipped, so the
 *     hidden <details> elements are out of the tab order and out of the
 *     accessibility tree. The visibility transition is delayed on close so the
 *     rows stay painted for the length of the slide.
 *   · Once the open transition finishes, max-height is released to `none`.
 *     A fixed pixel height would clip the panel the moment a shopper opens one
 *     of the accordions inside it.
 */
(function () {
  var REDUCED =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setLabel(toggle, expanded) {
    var label = toggle.querySelector('[data-collapsible-more-label]');
    if (!label) return;
    var next = expanded ? toggle.dataset.labelLess : toggle.dataset.labelMore;
    if (next) label.textContent = next;
  }

  function open(panel, toggle) {
    panel.classList.add('is-open');
    toggle.setAttribute('aria-expanded', 'true');
    setLabel(toggle, true);

    if (REDUCED) {
      panel.style.maxHeight = 'none';
      return;
    }
    panel.style.maxHeight = panel.scrollHeight + 'px';
  }

  function close(panel, toggle) {
    // Cannot transition away from `none`, so pin the current height first.
    panel.style.maxHeight = panel.scrollHeight + 'px';
    // Force the pinned height to be committed before the collapse starts.
    void panel.offsetHeight;

    panel.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');
    setLabel(toggle, false);
    panel.style.maxHeight = '0px';
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var wrappers = scope.querySelectorAll('[data-collapsible-more]');

    for (var i = 0; i < wrappers.length; i++) {
      var wrapper = wrappers[i];
      if (wrapper.dataset.collapsibleMoreInit === '1') continue;
      wrapper.dataset.collapsibleMoreInit = '1';

      var panel = wrapper.querySelector('[data-collapsible-more-panel]');
      var toggle = wrapper.querySelector('[data-collapsible-more-toggle]');
      if (!panel || !toggle) continue;

      bind(panel, toggle);
    }
  }

  function bind(panel, toggle) {
    toggle.addEventListener('click', function () {
      if (toggle.getAttribute('aria-expanded') === 'true') {
        close(panel, toggle);
      } else {
        open(panel, toggle);
      }
    });

    panel.addEventListener('transitionend', function (event) {
      if (event.target !== panel || event.propertyName !== 'max-height') return;
      if (panel.classList.contains('is-open')) {
        // Release the cap so an accordion opened inside is not clipped.
        panel.style.maxHeight = 'none';
      }
    });
  }

  // The theme editor scrolls to a selected block. A block inside the closed
  // panel would be invisible, so open the panel when one of them is selected.
  function openForBlock(blockEl) {
    if (!blockEl || !blockEl.closest) return;
    var panel = blockEl.closest('[data-collapsible-more-panel]');
    if (!panel) return;
    var wrapper = panel.closest('[data-collapsible-more]');
    if (!wrapper) return;
    var toggle = wrapper.querySelector('[data-collapsible-more-toggle]');
    if (!toggle || toggle.getAttribute('aria-expanded') === 'true') return;
    open(panel, toggle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    init(document);
    openForBlock(event.target);
  });
})();
